<template>
  <div>
    <div
      class="flex justify-between cursor-pointer items-center"
      @click="isExpanded = !isExpanded"
    >
      <div class="flex items-center">
        <button class="mr-3 text-blueDianne hover:text-blueDianne-700">
          <i
            :class="
              isExpanded
                ? 'fa-solid fa-chevron-down'
                : 'fa-solid fa-chevron-right'
            "
          ></i>
        </button>
        <div>
          <h4 class="text-xl">{{ author.name }}</h4>
          <ul class="form-label text-xs">
            <li
              v-for="affiliation in author.structuredAffiliations"
              :key="affiliation.institution"
            >
              {{ affiliation.institution }}
            </li>
          </ul>
        </div>
      </div>
      <div>
        {{
          author.normalizedFitScore
            ? author.normalizedFitScore + "%"
            : "No fit score available"
        }}
      </div>
    </div>
    <div v-if="isExpanded" class="mt-3">
      <div class="flex flex-wrap -mx-5">
        <div class="mx-5">
          <span class="form-label">Papers</span>
          <span class="text-sm"
            >{{ author.paperCount }} ({{ author.paperCountLast_5Years }} last
            five years)</span
          >
        </div>
        <div class="mx-5">
          <span class="form-label">HIndex</span>
          <span class="text-sm">{{ author.hIndex }}</span>
        </div>
        <div class="mx-5">
          <span class="form-label">Citations</span>
          <span class="text-sm"
            >{{ author.citationCount }} ({{
              author.influentialCitationCount
            }}
            influential)</span
          >
        </div>
        <div class="mx-5">
          <span class="form-label">Journal Quartile Counts</span>
          <span class="text-sm">{{ author.journalQuartileCounts }}</span>
        </div>
        <div class="mx-5">
          <span class="form-label">Years Active</span>
          <span class="text-sm"
            >{{ author.yearsActive }} ({{ author.firstPublishedYear }} -
            {{ author.latestPublishedYear }})</span
          >
        </div>
      </div>
      <div class="mt-5">
        <span class="form-label">Suitability Score & Reason</span>
        <span class="text-sm"
          >{{ author.suitability?.score }}:
          {{ author.suitability?.reason }}</span
        >
      </div>
      <div class="mt-5">
        <span class="form-label">Concept Score & Reason</span>
        <span class="text-sm"
          >{{ author.suitability?.conceptScore }}:
          {{ author.suitability?.conceptScoreReason }}</span
        >
      </div>
      <div class="mt-5">
        <span class="form-label">Good Fit Reason (Shown to Client)</span>
        <p class="bg-green-500/10 text-sm px-3 py-2 rounded">
          {{ author.suitability?.goodFitReason }}
        </p>
      </div>
      <span class="form-label mt-5">Most Relevant Paper Titles</span>
      <ul class="list-disc ml-5 text-sm">
        <li
          v-for="paperTitle in author.suitability?.mostRelevantPaperTitles"
          :key="paperTitle"
        >
          {{ paperTitle }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    author: Object,
  },
  data() {
    return {
      isExpanded: false,
    };
  },
};
</script>
